import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    
    // Preload image
    const img = new Image();
    img.src = '/img/leine2_neu_optimized.jpg';
    img.onload = () => setImageLoaded(true);
  }, []);

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className={`min-h-screen relative flex items-center justify-center bg-cover bg-center overflow-hidden transition-[filter] duration-600 ease-out ${
        imageLoaded ? 'blur-0' : 'blur-[20px]'
      }`}
      style={{ backgroundImage: `url(/img/leine2_neu_optimized.jpg)` }}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-zinc-900/85 to-zinc-800/90"></div>
      
      <div className="relative z-[2] text-center px-8 max-w-[900px] w-full">
        <div className={`transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'
        }`}>
          <p className="font-sans text-sm text-crimson uppercase tracking-[0.15em] font-semibold mb-6 opacity-0 animate-[fadeInUp_0.8s_ease_forwards_0.3s]">
            Handgefertigte Hundeleinen
          </p>
          
          <h1 className="font-display text-[7rem] md:text-[7rem] text-white font-bold m-0 leading-[0.95] tracking-tighter opacity-0 animate-[fadeInUp_0.8s_ease_forwards_0.5s] max-md:text-[3.5rem] max-md:tracking-tight">
            Leinenluder
          </h1>
          
          <p className="font-sans text-[1.15rem] text-zinc-300 mt-8 mb-12 font-normal leading-[1.7] max-w-[600px] mx-auto opacity-0 animate-[fadeInUp_0.8s_ease_forwards_0.7s] max-md:text-base max-md:mt-6 max-md:mb-10">
            Hochwertige Tauleinen und Halsbänder – Mit Liebe zum Detail gefertigt
          </p>
          
          <button 
            className="group relative font-sans px-11 py-[1.1rem] text-[0.95rem] font-semibold tracking-wide text-white bg-crimson border-2 border-crimson rounded-lg cursor-pointer transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] hover:text-crimson hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(220,38,38,0.3)] opacity-0 animate-[fadeInUp_0.8s_ease_forwards_0.9s] overflow-hidden before:absolute before:top-0 before:left-[-100%] before:w-full before:h-full before:bg-white before:transition-[left] before:duration-400 before:ease-[cubic-bezier(0.16,1,0.3,1)] before:-z-[1] hover:before:left-0 max-md:px-9 max-md:py-4 max-md:text-[0.9rem]"
            onClick={scrollToProjects}
          >
            Seilwerke entdecken
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-[30px] left-1/2 -translate-x-1/2 z-[2]">
        <div className="w-[30px] h-[50px] border-3 border-white rounded-[20px] relative animate-[bounce_2s_infinite] before:content-[''] before:absolute before:top-[10px] before:left-1/2 before:-translate-x-1/2 before:w-1 before:h-[10px] before:bg-crimson before:rounded before:animate-[scroll_2s_infinite]">
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(10px);
          }
        }
        
        @keyframes scroll {
          0% {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) translateY(20px);
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;

